<script lang="ts">
	import { fly } from 'svelte/transition';
	import { quintOut } from 'svelte/easing';
	import { CheckCircle2, AlertCircle, Info, X } from 'lucide-svelte';
	import { toast, type ToastVariant } from '$lib/stores/toast.svelte';

	function variantClasses(v: ToastVariant): string {
		if (v === 'success') return 'bandeau-tableau text-ink';
		if (v === 'error') return 'bandeau-danger text-ink';
		return 'rounded border border-mist bg-paper text-ink';
	}

	function iconColor(v: ToastVariant): string {
		if (v === 'success') return 'text-tableau';
		if (v === 'error') return 'text-danger';
		return 'text-marge';
	}
</script>

<!-- Live region for screen readers; visually positioned bottom-right on desktop, top on mobile. -->
<div
	class="pointer-events-none fixed inset-x-0 top-4 z-[100] flex flex-col items-center gap-2 px-4 sm:items-end sm:top-auto sm:bottom-4 sm:right-4 sm:left-auto sm:px-0"
	aria-live="polite"
	aria-atomic="false"
>
	{#each toast.items as item (item.id)}
		<div
			class="pointer-events-auto flex w-full max-w-md items-start gap-3 px-4 py-3 shadow-overlay {variantClasses(item.variant)}"
			role={item.variant === 'error' ? 'alert' : 'status'}
			in:fly={{ y: -10, duration: 220, easing: quintOut }}
			out:fly={{ x: 10, duration: 180, easing: quintOut }}
		>
			<span class="mt-0.5 shrink-0 {iconColor(item.variant)}">
				{#if item.variant === 'success'}
					<CheckCircle2 class="size-5" />
				{:else if item.variant === 'error'}
					<AlertCircle class="size-5" />
				{:else}
					<Info class="size-5" />
				{/if}
			</span>
			<p class="flex-1 text-sm leading-relaxed">{item.message}</p>
			{#if item.action}
				<button
					type="button"
					class="shrink-0 rounded border border-current/30 px-2.5 py-1 text-sm font-semibold transition-colors hover:bg-paper/60"
					onclick={() => {
						const run = item.action?.run;
						toast.dismiss(item.id);
						run?.();
					}}
				>
					{item.action.label}
				</button>
			{/if}
			<button
				type="button"
				class="shrink-0 rounded p-0.5 opacity-60 transition-opacity hover:opacity-100"
				onclick={() => toast.dismiss(item.id)}
				aria-label="Fermer la notification"
			>
				<X class="size-4" />
			</button>
		</div>
	{/each}
</div>
